import { FilterButton } from "./filter-button.model";

export class FilterConfiguration {
  buttons: FilterButton[] = [];
  displayMobile?: boolean = false;
}